export default defineNuxtPlugin({
  name: 'snackbar',
  parallel: true,
  setup () {
     
    const store = useSnackbarStore()

    const generateUID = str => (`${(Math.random(Date.now() * Math.random(100 + 50))).toString(32)}${Math.random().toString(16)}${str ? `-${strToKebabCase(str)}` : ''}`).replace(/\./g, '')

    /**
     * Snackbar Payload
     * @param {string} type - the type of snackbar (success, error, '')
     * example: $snackbar.success() or $snackbar.error()
     * 
     * @param {string} message - the message to be displayed
     * @param {string} layout - the layout of the snackbar (text, short cta, long cta)
     * @param {boolean} hasIcon - to show the icon
     * @param {boolean} hasCloseButton - to show the close button
     * @param {string} ctaText - the text of the cta button
     * @param {function} ctaCallback - the callback function to be called when the cta button is clicked
     * 
     * example:
     * $snackbar.success('Lorem ipsum dolor sit amet, 
     * consectetur adipiscing elit', {
     *    layout: 'short cta',
     *    hasIcon: true,
     *    hasCloseButton: true,  
     *    ctaText: 'Action',
     *    ctaCallback: () => {
     *      console.log('Snackbar CTA clicked')
     *    }
     * })
     */

    class Snackbar {
      success (message, payload = {}) {  
        if (!message) {
          return
        }

        payload.type = 'success'
        payload.id = `snack-${this.getUUID()}`
        payload.text = message

        store.updateSnackbar(payload)
      }

      error (message, payload = {}) {
        if (!message) {
          return
        }

        payload.type = 'error'
        payload.id = `snack-${this.getUUID()}`
        payload.text = message

        store.updateSnackbar(payload)
      }

      remove (id) {
        if (!id) {
          return
        }

        store.removeSnackbar(id)
      }

      /*
       * Generate a unique ID for the snackbar
       * If the ID already exists in the snackbars obj,
       * it generate a new one
       * @param str
       * @returns {string}
      */
      getUUID (str) {
        const uuid = generateUID(str)

        return Object.keys(store.snackbars).includes(uuid)
          ? uuid
          : generateUID(str)
      }
    }

    return {
      provide: {
        snackbar: new Snackbar()
      }
    }
  }
})